import { render, staticRenderFns } from "./ReactivateTechnician.vue?vue&type=template&id=fad8ff96"
import script from "./ReactivateTechnician.vue?vue&type=script&lang=js"
export * from "./ReactivateTechnician.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports